module.exports = __webpack_public_path__ + "media/images/instagram-4bd4a3cb2dbc5631444eee37b275b051.svg";